const { createContext, useContext } = require("react");

const MainContext = createContext()

export{
    MainContext,
    useContext
}